import { SVGProps } from 'react'

const DelegateIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="15"
    height="12"
    viewBox="0 0 15 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="Group">
      <path
        id="Vector"
        d="M14.4059 4.30706L14.4601 4.24135L14.4106 4.31061C14.625 4.46379 14.7037 4.74059 14.6101 4.99012C14.515 5.24396 14.2786 5.41477 14.0152 5.41477H0.882292V4.16561H11.8841H12.2194L11.9566 3.95748L8.84231 1.49129L9.62368 0.506742L14.4059 4.30706Z"
        fill="currentColor"
        strokeWidth="0.233333"
      />
      <path
        id="Vector_2"
        d="M3.60133 8.06808L6.60494 10.5142L5.80848 11.4825L1.21027 7.70216L1.21031 7.70211L1.20735 7.69983C1.00906 7.54719 0.929465 7.26914 1.02265 7.01903C1.1174 6.7835 1.35384 6.61178 1.61806 6.61178H14.4359L14.4359 7.86095H3.67501H3.347L3.60133 8.06808Z"
        fill="currentColor"
        strokeWidth="0.233333"
      />
    </g>
  </svg>
)
export default DelegateIcon
